/**
 * @ngdoc directive
 * @module components.pagination
 * @name components.pagination:paginationPageLinks
 * @restrict E
 * @requires pagination
 * @description
 * Lists links to the pages of paginated content.
 * @example
    <example module="dataExample">
        <file name="index.html">
            <div ng-controller="exampleController">
                <pagination data="exampleData">
                    <p>Current Page: {{$ctrl.page}}</p>
                    <ul>
                        <li ng-repeat="item in $ctrl.items">{{item}}</li>
                    </ul>
                    <pagination-page-links spacing="[2,3,2]">Click me to load more!!!</pagination-page-links>
                </pagination>
            </div>
        </file>
        <file name="script.js">
            (function() {
                angular.module('dataExample', ['components.pagination'])
                    .controller('exampleController', exampleController);

                exampleController.$inject = ['$scope'];
                function exampleController($scope) {
                    var data = [];
                    for (var i=0; i<1000; i++) {
                        data.push('example ' + i);
                    }
                    $scope.exampleData = data;
                }
            })();
        </file>
    </example>
 */

(function () {
	angular.module('components.pagination')
		.component('paginationPageLinks', {
			require: {
				'pagination': '^pagination'
			},
			bindings: {
                'spacing': '<'
			},
            template: '<a class="shifter" ng-click="$ctrl.prevPage()" ng-class="{disabled: $ctrl.pagination.page === 1}"><span class="fa fa-chevron-left"></span></a><ul><li ng-repeat="block in $ctrl.blocks"><span class="divider" ng-hide="$ctrl.blocks[$index - 1][$ctrl.blocks[$index - 1].length - 1] + 1 === block[0] || block[0] - 1 === $ctrl.pagination.page"></span><a class="page" ng-repeat="link in block" ng-click="$ctrl.toPage(link)" ng-class="{active: $ctrl.pagination.page == link}"><span>{{link}}<span></a><span ng-hide="$ctrl.pagination.page <= block[block.length - 1] || $ctrl.blocks[$index + 1][0] <= $ctrl.pagination.page"><span class="divider" ng-hide="block[block.length - 1] + 1 === $ctrl.pagination.page"></span><a class="page active"><span>{{$ctrl.pagination.page}}</span></a></span></li></ul><a class="shifter" ng-click="$ctrl.nextPage()" ng-class="{disabled: $ctrl.pagination.page === $ctrl.pagination.pageLimit}"><span class="fa fa-chevron-right"></span></a>',
            controller: paginationPageLinksController
		});

	paginationPageLinksController.$inject = ['$scope', '$element'];
	function paginationPageLinksController($scope, $element) {
		var ctrl = this;
		ctrl.$onInit = function () {
		    $element.addClass('ng-hide');
		    $scope.$watch('$ctrl.pagination.$promise', function (promise) {
		        if (promise !== undefined) {
		            promise.then(function (data) {
		                if (data.rows > data.items.length) {
		                    $element.removeClass('ng-hide');
		                    ctrl.$$calculateSpacing();
		                }
		                else {
		                    $element.addClass('ng-hide');
		                }
		            });
		        }
		    });
		}

		ctrl.$$calculateSpacing = function () {
		    var total = 0;
		    for (var i = 0; i < ctrl.spacing.length; i++) {
		        total += ctrl.spacing[i];
		    }
		    var set = [];
		    for (var i = 1; i <= ctrl.pagination.pageLimit; i++) {
		        set.push(i);
		    }
		    if (total >= ctrl.pagination.pageLimit)
		        ctrl.blocks = [set];
		    else {
		        var gaps = ctrl.pagination.pageLimit - total;
		        var space = gaps / (ctrl.spacing.length - 1);
		        ctrl.blocks = [];
		        var pos = 0;
		        for (var i = 0; i < ctrl.spacing.length; i++) {
		            ctrl.blocks.push(set.slice(Math.round(pos), ctrl.spacing[i] + pos));
		            pos += ctrl.spacing[i] + space;
		        }
		    }
		}

		ctrl.toPage = function (page) {
		    ctrl.pagination.$$toPage(page, true);
		}

		ctrl.prevPage = function() {
		    ctrl.pagination.prevPage(true);
		}

		ctrl.nextPage = function() {
		    ctrl.pagination.nextPage(true);
		}
	}
})();